export enum ConnectorNames {
  MetaMask = 'metaMaskSDK',
  Injected = 'injected',
  WalletConnect = 'walletConnect',
  TrustWallet = 'trust',
  WalletLink = 'coinbaseWalletSDK',
}
